/**
 * react-intl strings for GuardRails course creation and child-entity modals.
 * @module Workspace/components/GuardRailsSelectorModal/messages
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.guardRails';

export default defineMessages({
  chooseCourseType: {
    id: `${scope}.chooseCourseType`,
    defaultMessage: 'Choose a Course Type',
  },
  bronteViewerEText: {
    id: `${scope}.bronteViewerEText`,
    defaultMessage: 'Bronte Viewer (eText)',
  },
  epubEText: {
    id: `${scope}.epubEText`,
    defaultMessage: 'ePub (eText)',
  },
  other: {
    id: `${scope}.other`,
    defaultMessage: 'Other',
  },
  othersSubtitle: {
    id: `${scope}.othersSubtitle`,
    defaultMessage: 'iLabs, CRX, etc.',
  },
  createCourse: {
    id: `${scope}.createCourse`,
    defaultMessage: 'Create a Course',
  },
  createUnit: {
    id: `${scope}.createUnit`,
    defaultMessage: 'Create a Unit',
  },
  createLesson: {
    id: `${scope}.createLesson`,
    defaultMessage: 'Create a Lesson',
  },
  createScreen: {
    id: `${scope}.createScreen`,
    defaultMessage: 'Create a Screen',
  },
  courseName: {
    id: `${scope}.courseName`,
    defaultMessage: 'Course Name',
  },
  unitName: {
    id: `${scope}.unitName`,
    defaultMessage: 'Unit Name',
  },
  lessonName: {
    id: `${scope}.lessonName`,
    defaultMessage: 'Lesson Name',
  },
  screenName: {
    id: `${scope}.screenName`,
    defaultMessage: 'Screen Name',
  },
  createButton: {
    id: `${scope}.createButton`,
    defaultMessage: 'CREATE',
  },
  creatingCourse: {
    id: `${scope}.creatingCourse`,
    defaultMessage: 'Creating course',
  },
  courseCreatedSuccess: {
    id: `${scope}.courseCreatedSuccess`,
    defaultMessage: 'Course "{courseName}" created successfully',
  },
});
